import { FC } from "react";
import classnames from 'classnames';
import { LayOutPageContentHeaderProps, LayOutPageItemEnum, } from "../interface";

const LayOutPageContentHeader: FC<LayOutPageContentHeaderProps> = props => {
  const { children, className, title, operationButton, ...restProps } = props;
  const classes = classnames('content-header', className);
  return (
    <div className={classes} {...restProps}>
      <div className="content-header-title">{title || ''}</div>
      <div className="content-header-operation">
        {operationButton}
      </div>
    </div>
  );
};

LayOutPageContentHeader.displayName = LayOutPageItemEnum.ContentHeader;

export default LayOutPageContentHeader;